import React from 'react';
import { CreativeFormPreview as SharedCreativeFormPreview } from '@egreact/shared';
import Navbar from '../../components/Navbar/Navbar';
import StoreToken from '../../components/StoreToken';
import './configure';

const CreativeFormPreview = () => (
  <SharedCreativeFormPreview
    useStoreToken={StoreToken}
    // No `location`: given one, the Navbar builds a tokenised URL to compare
    // against, and that builder redirects to login while the token is still in
    // the address bar rather than in storage. Without it the Navbar
    // short-circuits, and its logo links to the app root.
    chrome={<Navbar title="Dashboard" />}
  />
);

export default CreativeFormPreview;
